import { render, staticRenderFns } from "./OrderConfirmForm.vue?vue&type=template&id=d07097e0&"
import script from "./OrderConfirmForm.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports